__turbopack_context__.v({
  "root": "Prose-module__kNPEWG__root",
});
